<template>
  <div id="app">

    <template  v-if="!isAppLoaded">
        <div class="loading">
            Carregando...
        </div>
        </template>

    <template v-else>

        <template v-if="isCompanyLoaded">
            <Navbar />
            <router-view />
            <Footer />
        </template>
        <template v-else>
            <img height="100%" width="100%" :src="require('@/assets/errors/404.png')" />
        </template>

    </template>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import { mapGetters } from 'vuex'

export default {
    name: 'App',
    components: {
        Navbar,
        Footer,
    },
    data: vm => ({
        isAppLoaded: false,
    }),
    async beforeCreate() {
        this.isAppLoaded = false
        
        await this.$store.dispatch('company/fetchData')
            // Obs. Não pode ser catch(this.errorHandler) pois não funciona no beforeCreate
            .catch(e => {
                this.errorHandler(e)
            })

        await this.$store.dispatch('prizes/getPrizeData')
            .catch(e => {
                this.errorHandler(e)
            })

        await this.$store.dispatch('level/getLevelsData')
            .catch(e => {
                this.errorHandler(e)
            })

        await this.$store.dispatch('benefit/getBenefitsData', this.levelsId)
            .catch(e => {
                this.errorHandler(e)
            })

        if (!this.isCompanyLoaded) {
            this.isAppLoaded = true
            return
        }

        this.isAppLoaded = true
    },
    methods: {
        errorHandler(e) {
            this.$console.error(e)
        },
    },
    computed: {
        ...mapGetters({
            isCompanyLoaded: 'company/isLoaded',
            levelsId: 'level/levels_id',
        }),
    },
}
</script>

<style scoped>
.loading{
    display:  flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 10vh;
    color: #212121;
    font-size: 1.5rem;
}
</style>